import { defineCompositeMeasurement } from './CompositeMeasurement.js';
/**
 * Patient-reported blood pressure: systolic + diastolic in mmHg, under LOINC panel 85354-9 with
 * component codes systolic 8480-6 / diastolic 8462-4. Defined for the intake form; not ingested as an
 * observation today (kept ready for future ingestion).
 */
export const BloodPressure = defineCompositeMeasurement({
    panelLoinc: '85354-9',
    canonical: 'mmHg',
    components: {
        systolic: { loinc: '8480-6' },
        diastolic: { loinc: '8462-4' },
    },
});
//# sourceMappingURL=BloodPressure.js.map